import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-profile-analytics-lessons',
    templateUrl: './profile-analytics-lesson.component.html',
    styleUrls: ['./profile-analytics-lesson.component.scss']
})
export class ProfileAnalyticsLessonComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
